<template>
  <div class="wrapper" :id="`date-field-${getFieldID(schema)}`">
    <template v-if="schema.attributes.editing && !disabledForAdminOnly">
      <div>
        <date-time-picker
          v-if="!empty"
          class="date-row"
          :id="getFieldID(schema)"
          :disabled="false"
          :defaultDate="momentDate"
          :parentEleId="`date-field-${getFieldID(schema)}`"
          :showDate="true"
          :showTime="false"
          :uniqueId="`date-field-${getFieldID(schema)}`"
          :withColumns="false"
          @dateObject="setDate"
          ref="dateTimePicker"
          width="250"
        ></date-time-picker>
        <button
          @click="setInitialDate"
          class="btn btn-link"
          v-if="empty"><font-awesome-icon :icon="faIcons.faCalendarAlt" />&nbsp;
            Select Date</button>
        <button
          @click="clearDate"
          class="btn btn-link btn-clear" v-if="!empty"></button>

      </div>
    </template>
    <template v-if="!schema.attributes.editing">
      <span v-if="!lodash.isNull(value)" class="response">
        {{ dateFormatted }}
      </span>
      <span v-else style="font-style: italic; color: #555">
        Not available
      </span>
    </template>
    <div
      class="form-input-hint text-error"
      v-if="schema.attributes.editing && disabledForAdminOnly">
      Field is restricted to site administrators.
    </div>
  </div>
</template>

<script>
// This is a lightly modified version of vue-form-generator's input field.
import _ from 'lodash';
import moment from 'moment';

import { MixinDataToReactiveData } from 'assets/js/util';

import { abstractField } from 'components/Widgets/FormGenerator';

import DateTimePicker from 'components/Widgets/DateTimePicker';
import FieldCommon from './FieldCommon';

export default {
  name: 'field-q-date',

  mixins: [abstractField, FieldCommon],

  setup() {
    const afd = MixinDataToReactiveData(abstractField);
    const fcd = MixinDataToReactiveData(FieldCommon);
    return {
      ...afd,
      ...fcd,
    };
  },

  components: {
    DateTimePicker,
  },

  created() {
    if (this.value) {
      this.momentDate = moment(this.value);
      this.empty = false;
    } else {
      // Set the default value.
      this.value = '';
      this.momentDate = null;
      this.empty = true;
    }
  },

  computed: {
    // dateFormatted formats the date.
    dateFormatted() {
      if (!this.value) return '';
      let format = 'YYYY-MM-DD';
      if (this.dateOptions && this.dateOptions.dateFormat &&
        this.dateOptions.dateFormat.length === 2) {
        format = this.dateOptions.dateFormat[0];
      }
      return moment(this.value).format(format);
    },

    dateOptions() {
      return this.schema.dateOptions
        || { dateFormat: ['YYYY-MM-DD', '%Y-%m-%d'] };
    },
  },

  data() {
    return {
      momentDate: moment(),
      uniqueId: this.uuid4(),
      empty: true,
    };
  },

  methods: {
    clearDate() {
      this.empty = true;
      this.momentDate = null;
      this.value = '';
    },

    setDate(val) {
      // Copy into moment date.
      this.empty = false;
      this.momentDate = moment(val.dateMoment);
      this.value = this.momentDate.format('YYYY-MM-DD');
    },

    async setInitialDate() {
      // Set to now.
      this.setDate({ dateMoment: moment() });
      await this.$nextTick();
      this.$refs.dateTimePicker.FocusDatePicker();
    },
  },

  mounted() {
  },
};
</script>

<style scoped lang="scss">
  @import "~assets/css/colors";

  .response {
    &.empty-value {
      font-weight: normal;
      color: $greycolor;
    }
  }

  .date-row {
    width: 10em;
    float: left;
  }

  .btn-link {
    border: none !important;
    padding: 0 !important;
  }

  .btn-clear {
    line-height: 1.5 !important;
    padding-left: 1em!important;
    height: 2em !important;
    width: 3em !important;
    margin-top: 0em !important;
    margin-left: -1em !important;
  }

  .btn-clear:hover {
    background: none !important;
  }
</style>
